module.exports = __webpack_public_path__ + "media/flags/ai-134cde68.svg";